import React from 'react'
import styles from './styles/generic-components.module.scss'
import WTNSpinner from 'components/generic/WTNSpinner'
import cx from 'classnames'
import { ClassNamesProps } from 'types/utilities'

type ClassKeys = 'container' | 'spinner'
interface Props extends ClassNamesProps<ClassKeys> {
  containerHeight?: number
  spinnerWidth?: number
  fullScreen?: boolean
}

const LoadingSpinnerWithContainer = ({
  classNames,
  containerHeight = 0,
  spinnerWidth = 90,
  fullScreen = false,
}: Props) => {
  return (
    <div
      className={cx(styles.loadingSpinnerContainer, classNames?.container, {
        [styles.minHeightFull]: fullScreen,
      })}
      style={containerHeight ? { minHeight: containerHeight } : {}}
    >
      <WTNSpinner width={spinnerWidth} className={classNames?.spinner} />
    </div>
  )
}

export default LoadingSpinnerWithContainer
